// extracted by mini-css-extract-plugin
export default {"faro":"NotFoundPage_faro__GErmh"};